<div class="tw-m-auto tw-text-main" aria-live="polite" aria-atomic="false">
  <ng-template [cdkPortalOutlet]="content"></ng-template>
</div>
